export default __webpack_public_path__ + "static/media/happy-older-students-classroom.20bf4f14.jpg";